import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum.js';

export default Object.freeze({
	GENERAL: `${RouteNames.COGNITIVE_PROFILES}-general`,
	PERMISSIONS: `${RouteNames.COGNITIVE_PROFILES}-permissions`,
});
